module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-fa-chai.99a13bee.png";